import React from "react";
import { Leaf } from "lucide-react";
import { formatCo2 } from "@/lib/constants";

export function Co2Badge({ kg, className = "" }) {
  if (!kg) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-sm px-2 py-0.5 text-[11px] font-medium ${className}`}
      data-testid="co2-badge"
      title="CO₂ risparmiata riempiendo un viaggio a vuoto"
    >
      <Leaf size={12} /> {formatCo2(kg)} CO₂ risparmiata
    </span>
  );
}
